import { render } from "./CustomerItem.vue?vue&type=template&id=46b7214a"
import script from "./CustomerItem.vue?vue&type=script&lang=js"
export * from "./CustomerItem.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__